/**
 * pub/subパターン
 */
export class Pubsub {
	topics: {
		string?: {
			id: number,
			cb: () => any
		}[]
	};
	#subCount: number;

	constructor() {
		this.topics = {}
		this.#subCount = 0;
	}

	/**
	 * topicsを購読
	 */
	sub(name:string , cb: () => any) {
		const id = this.#subCount++
		this.topics[name] = this.topics[name] || [];
		this.topics[name].push({
			id,
			cb
		})
		return id
	}

	/**
	 * topicsの購読をやめる
	 */
	unsub(id) {
		Object.keys(this.topics).forEach(k => {
			this.topics[k] = this.topics[k].filter(t => t.id !== id)
		})
	}

	/**
	 * トピックスに変更を通知
	 */
	pub(name: string, args?: any) {
		if (!this.topics[name]) { return }
		this.topics[name].forEach(sub => {
			sub.cb(args)
		})
	}
}

declare global {
	interface Window {
		pubsub: Pubsub
	}
}

/**
 * pub/subパターン
 */
export const pubsub = window.pubsub = new Pubsub();